import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Button } from "@mui/material";
import { AppContext } from "../Store";
import { IChild } from "../shared/types/child";
import ObservationsPrintView from "../shared/ObservationsPrintView";

const ObservationsPrintPage: React.FC = () => {
  const { childId } = useParams<{ childId: string }>();
  const context = useContext(AppContext);
  const { childrenData } = context;
  const [child, setChild] = useState<IChild>();

  useEffect(() => {
    if (!childrenData) return;
    const child = childrenData.find((child) => child.id === childId);
    setChild(child);
  }, [childrenData, childId]);

  const handlePrint = () => {
    window.print();
  };

  return (
    <Container maxWidth="lg" style={{ minHeight: "100vh" }}>
      <div className="no-print" style={{ marginBottom: 16, display: "flex", gap: 8 }}>
        <Button variant="contained" color="primary" onClick={handlePrint}>
          Print
        </Button>
        {!child && (
          <Button variant="contained" color="primary">
            Go Back
          </Button>
        )}
      </div>
      {child && <ObservationsPrintView child={child} />}
    </Container>
  );
};

export default ObservationsPrintPage;
